import {
  getSaveRelationship
} from "@/api/weiXin/weixin";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async getSaveRelationship(context, params) {
      const { data } = await getSaveRelationship(params);
      return data;
    }
  }
};
